import React from 'react';
function TrainingTracker() {
  return (
    <div className="placeholder-page">
      <div className="placeholder-icon">🎓</div>
      <div className="placeholder-title">Training Tracker</div>
      <div className="placeholder-sub">End user training planning, delivery tracking, and completion sign-off. Coming soon.</div>
    </div>
  );
}
export default TrainingTracker;